<template>
  <svg
    @click="$emit('click')"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    :fill="fill"
    :class="`w-${width} h-${height} `"
  >
    <path
      fill-rule="evenodd"
      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      default: 6,
    },
    height: {
      default: 6,
    },
    fill: {
      default: "currentColor",
    },
    stroke: {
      default: "currentColor",
    },
  },
};
</script>
